import { Component } from '@angular/core';
import { BookableStorageLocation } from '@luggagehero/shared/interfaces';

import { BaseComponent } from '../../../core';

@Component({
  template: '',
  selector: 'lh-pricing-modal-base',
  standalone: false,
})
export abstract class PricingModalBaseComponent extends BaseComponent {
  abstract get shop(): BookableStorageLocation;
}
